"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importDefault(require("react"));
const Horizontal_1 = __importDefault(require("../Horizontal"));
const Pane_1 = __importDefault(require("../Pane"));
const Vertical_1 = __importDefault(require("../Vertical"));
function Columns(props) {
    const { scroll = false, noOfCols = 2, children = [] } = props, otherProps = __rest(props, ["scroll", "noOfCols", "children"]);
    const chunks = calcChunks(children, Math.min(children.length, noOfCols));
    return (react_1.default.createElement(Horizontal_1.default, Object.assign({ style: { overflowY: scroll ? 'scroll' : 'visible', overflowX: 'hidden' } }, otherProps), (0, range_1.default)(noOfCols).map((col, idx) => (react_1.default.createElement(Pane_1.default, { key: 'col' + idx, grow: true, visible: true },
        react_1.default.createElement(Vertical_1.default, { gutter: true, shrink: true }, chunks[col]))))));
}
exports.Columns = Columns;
exports.default = Columns;
function calcChunks(arr, noOfCols) {
    const chunks = (0, range_1.default)(noOfCols).map(() => []);
    arr.forEach((item, idx) => {
        chunks[idx % noOfCols].push(item);
    });
    return chunks;
}
